import { Col, Form } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import hocFrom from 'components/forms/HocFrom';
import InputFarsi from 'components/inputs/InputFarsi';
import Switchrs from 'components/inputs/Switchrs';
import Loader from 'components/layout/Loader';
import InputPic from 'components/inputs/InputPic';
import InputDate from 'components/inputs/InputDate';
import InputNumber from 'components/inputs/InputNumber';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
// import FileUploader from 'components/fileUploader';

const FormBusinessCompany = ({
  handleSendWithSimCommand,
  handleUpdateWithSimCommand,
  loding,
  handelLoadingform,
  LoadingForm,
  dataUpdate,
  handelsetdataForm,
  formdata,
}) => {
  const [responsible, setResponsible] = useState({});
  const [startDate, setStartDate] = useState();
  const [startclock, setStartclock] = useState();
  const { authentication, urldashboard } = useContext(DashboardContext);
  const [settings, setsettings] = useState();

  const getExpertdocumenttypeApiHandler = async () => {
    try {
      const res = (
        await axios.get(`${urldashboard}/common/expertdocumenttype`, {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8 ',
          },
        })
      )?.data?.data;

      setsettings(res);
    } catch (err) {}
  };

  const handelCheckboxValue = (e) => {
    handelsetdataForm((prevState) => ({
      ...prevState,
      setting: {
        ...prevState.setting,
        expertDocumentTypes: prevState.setting?.expertDocumentTypes?.some(
          (item) => item === parseInt(e.target.value)
        )
          ? prevState.setting?.expertDocumentTypes?.filter(
              (item) => item !== parseInt(e.target.value)
            )
          : [
              ...prevState.setting?.expertDocumentTypes,
              parseInt(e.target.value),
            ],
      },
    }));
  };

  useEffect(() => {
    handelLoadingform(true);
    getExpertdocumenttypeApiHandler();
    if (!dataUpdate.id) {
      handelsetdataForm({
        setting: {
          expertDocumentTypes: [],
        },
      });
    }
    handelLoadingform(false);
  }, []);

  const handelValue = (name, value) => {
    setStartDate(
      value.hasOwnProperty('dateOfViewReport')
        ? value.dateOfViewReport.split('T')[0]
        : ''
    );
    setStartclock(
      value.hasOwnProperty('dateOfViewReport')
        ? value.dateOfViewReport.split('T')[1]
        : ''
    );
    switch (name) {
      case 'name':
        handelsetdataForm({ ...formdata, name: value });
        break;
      case 'shortName':
        handelsetdataForm({ ...formdata, shortName: value });
        break;
      case 'logoPictureFile':
        handelsetdataForm({ ...formdata, logoPictureFile: value });
        break;
      case 'responsibleUserId':
        handelsetdataForm({ ...formdata, responsibleUserId: value });
        break;
      case 'dateOfViewReport':
        setStartDate(value);
        handelsetdataForm((prevState) => ({
          ...prevState,
          setting: {
            ...prevState.setting,
            dateOfViewReport: `${value}T${startclock ? startclock : '00:00'}`,
          },
        }));
        break;
      case 'enableOutputTimeByUser':
        handelsetdataForm((prevState) => ({
          ...prevState,
          setting: { ...prevState.setting, enableOutputTimeByUser: value },
        }));
        break;
      case 'hasAccessToDocuments':
        handelsetdataForm((prevState) => ({
          ...prevState,
          setting: {
            ...prevState.setting,
            hasAccessToDocuments: value,
            expertDocumentTypes: value
              ? prevState.setting.expertDocumentTypes
              : [],
          },
        }));

        break;
      case 'enableInputTimeByUser':
        handelsetdataForm((prevState) => ({
          ...prevState,
          setting: { ...prevState.setting, enableInputTimeByUser: value },
        }));
        break;
      default:
        break;
    }
  };

  const handelSubmit = (event) => {
    event.preventDefault();
    handelLoadingform(true);
    if (
      formdata.setting?.hasAccessToDocuments &&
      formdata.setting?.expertDocumentTypes?.length < 1
    ) {
      handelLoadingform(false);
      return toaster.error('حداقل یک مدرک را انتخاب نمایید.');
    }

    if (!formdata.name) {
      handelLoadingform(false);
      return toaster.error('وارد کردن نام شرکت اجباری است.');
    }

    if (!formdata.shortName) {
      handelLoadingform(false);
      return toaster.error('وارد کردن نام اختصاری شرکت اجباری است.');
    }

    const responsibleInfo = {
      firstName: responsible?.firstName ?? dataUpdate?.responsible?.firstName,
      lastName: responsible?.lastName ?? dataUpdate?.responsible?.lastName,
      phoneNumber:
        responsible?.phoneNumber ?? dataUpdate?.responsible?.phoneNumber,
    };

    if (!responsibleInfo.firstName) {
      handelLoadingform(false);
      return toaster.error('لطفا نام نماینده را وارد کنید.');
    }

    if (!responsibleInfo.lastName) {
      handelLoadingform(false);
      return toaster.error('لطفا نام خانوادگی نماینده را وارد کنید.');
    }

    if (!responsibleInfo.phoneNumber) {
      handelLoadingform(false);
      return toaster.error('لطفا شماره موبایل نماینده را وارد کنید.');
    }

    const command = {
      ...formdata,
      responsible: responsibleInfo,
    };

    dataUpdate.name
      ? handleUpdateWithSimCommand(command)
      : handleSendWithSimCommand(command);
  };

  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form method='post'>
          <Form.Row>
            <Col>
              <InputFarsi
                name='name'
                handelValue={handelValue}
                defaultValue={dataUpdate?.name}
                label='نام شرکت'
              />
            </Col>
            <Col>
              <InputFarsi
                name='shortName'
                handelValue={handelValue}
                defaultValue={dataUpdate?.shortName}
                label='نام اختصاری شرکت'
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputFarsi
                name='firstName'
                handelValue={(_, value) =>
                  setResponsible({ ...responsible, firstName: value })
                }
                defaultValue={dataUpdate?.responsible?.firstName}
                label='نام نماینده'
              />
            </Col>
            <Col>
              <InputFarsi
                name='lastName'
                handelValue={(_, value) =>
                  setResponsible({ ...responsible, lastName: value })
                }
                defaultValue={dataUpdate?.responsible?.lastName}
                label='نام خانوادگی نماینده'
              />
            </Col>
            <Col>
              <InputNumber
                label='شماره موبایل نماینده'
                defaultValue={dataUpdate?.responsible?.phoneNumber}
                name='phoneNumber'
                maxLength={11}
                handelValue={(_, value) =>
                  setResponsible({ ...responsible, phoneNumber: value })
                }
              />
            </Col>
          </Form.Row>
          <Form.Row className='mt-2 mb-5 align-items-center'>
            <Col>
              <InputDate
                label='تاریخ نمایش سفارشات'
                name='dateOfViewReport'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate?.setting?.dateOfViewReport?.split('T')[0]
                }
              />
            </Col>
            <Col>
              <InputPic
                label='انتخاب لوگو'
                name='logoPictureFile'
                defaultValue={dataUpdate.logoPath}
                handelValue={handelValue}
              />
              <img
                alt='لوگو'
                src={dataUpdate.logoPath}
                style={{ width: 200, height: 100 }}
              />
            </Col>
          </Form.Row>
          <Form.Row className='align-items-center'>
            <Col>
              <Switchrs
                name='enableInputTimeByUser'
                handelValue={handelValue}
                label='قابلیت تنظیم ساعت ورود'
                defaultChecked={formdata?.setting?.enableInputTimeByUser}
              />
            </Col>
            <Col>
              <Switchrs
                name='enableOutputTimeByUser'
                handelValue={handelValue}
                label='قابلیت تنظیم ساعت خروج'
                defaultChecked={formdata?.setting?.enableOutputTimeByUser}
              />
            </Col>
            <Col>
              <Switchrs
                name='hasAccessToDocuments'
                handelValue={handelValue}
                label='قابلیت دیدن مدارک نیرو'
                defaultChecked={formdata?.setting?.hasAccessToDocuments}
              />
            </Col>
            <Col>
              <Switchrs
                name='isActive'
                handelValue={(_, value) =>
                  handelsetdataForm({ ...formdata, isActive: value })
                }
                label='آیا فعال باشد؟'
                defaultChecked={formdata?.isActive || dataUpdate?.isActive}
              />
            </Col>
          </Form.Row>
          <hr />
          <Form.Row>
            {formdata?.setting?.hasAccessToDocuments && (
              <Form.Row>
                {settings?.map((res) => (
                  <Col md={3} mt={4}>
                    <Form.Check
                      name='expertDocumentTypes'
                      label={res?.label}
                      type='checkbox'
                      defaultChecked={dataUpdate?.setting?.expertDocumentTypes?.includes(
                        res?.value
                      )}
                      onChange={handelCheckboxValue}
                      value={res?.value}
                    />
                  </Col>
                ))}
              </Form.Row>
            )}
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate.name ? (
                  'ثبت ویرایش'
                ) : (
                  'ثبت'
                )}
              </button>
            </Col>
          </Form.Row>
        </Form>
      )}
    </>
  );
};
export default hocFrom(FormBusinessCompany);
